// extracted by mini-css-extract-plugin
module.exports = {"dots":"ActionButtons_dots__QKmx2"};